import * as TelemetryApi from '@bmai/telemetry-api-client';
import { ApiClientFactory } from './ApiClientFactory';

const configuration = new TelemetryApi.Configuration(ApiClientFactory.createConfig('/_telemetry'));

export const telemetryClient = ApiClientFactory.instantiateApis(TelemetryApi, configuration);
